import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user";
import filter from "./modules/filter";
import overview from "./modules/overview";
import customanalysis from "./modules/customanalysis";
import taganalysis from "./modules/taganalysis";
import userlist from "./modules/userList";
Vue.use(Vuex);

const actions = {
  resetAllData: ({ commit }) => {
    commit("user/resetState", null, { root: true });
    commit("filter/resetState", null, { root: true });
    commit("overview/resetState", null, { root: true });
    commit("customanalysis/resetState", null, { root: true });
    commit("taganalysis/resetState", null, { root: true });
    
  },
};
export default new Vuex.Store({
  strict: true,
  actions,
  modules: {
    user,
    filter,
    overview,
    customanalysis,
    taganalysis,
    userlist,
  },
});
